import { Button, Input, Modal, Radio, Space, Tag, Divider } from "antd";
import React, { useState } from "react";
import { $t } from "~/i18n.js";
import { useSelector } from "react-redux";
import { selectElementByID } from "~/lib/helpers.js";
import { Inspection } from "~/pages/materiaal/tabs/status/inspection.jsx";

export const KistStatusHangarModal = ({
  open,
  onClose,
  onSelect,
  is_today,
}) => {
  const [selectedKistID, setSelectedKistID] = useState(null);
  const [showPriveKistSelection, setShowPriveKistSelection] = useState(false);
  const [priveKistSearchTerm, setPriveKistSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);

  const { inspections } = useSelector((state) => state.materiaal);
  const { kisten, kistStatus } = useSelector((state) => state.flights);
  const { profile } = useSelector((state) => state.persist);
  const priveKisten = kisten.filter((kist) => kist.category === "prive");

  // Filter private kisten based on search term
  const filteredPriveKisten = priveKisten.filter(
    (kist) =>
      !priveKistSearchTerm ||
      kist.registratie
        ?.toLowerCase()
        .includes(priveKistSearchTerm.toLowerCase()) ||
      kist.callsign?.toLowerCase().includes(priveKistSearchTerm.toLowerCase())
  );

  const handleSelect = async () => {
    if (selectedKistID) {
      setLoading(true);
      const kist = selectElementByID(kisten, "id", selectedKistID);
      await onSelect({ uuid: kist?.flight_uuid, kist });
      setLoading(false);
      handleClose();
    }
  };

  const handleClose = () => {
    setSelectedKistID(null);
    setShowPriveKistSelection(false);
    setPriveKistSearchTerm("");
    onClose();
  };

  return (
    <Modal
      title={$t("Selecteer kist uit hangaar")}
      confirmLoading={loading}
      open={open}
      onClose={handleClose}
      onCancel={handleClose}
      okText={$t("Selecteer")}
      cancelText={$t("Annuleren")}
      onOk={handleSelect}
    >
      <div className="column" style={{ gap: 12, alignItems: "flex-start" }}>
        <Radio.Group
          onChange={(event) => setSelectedKistID(event.target.value)}
          value={selectedKistID}
        >
          <Space direction="vertical">
            {(() => {
              try {
                // Make sure kistStatus is an array before mapping
                const kistArray = Array.isArray(kistStatus) ? kistStatus : [];
                return kistArray.map(
                  (kist, key) =>
                    kist.status === "hangaar" && (
                      <Radio key={key} value={kist.id}>
                        <div style={{ display: "flex", gap: 24 }}>
                          <p>
                            {kist.callsign} {kist.registratie}
                          </p>
                          {is_today &&
                            kist?.material_status === "in onderhoud" && (
                              <Tag color="warning">{$t("In onderhoud")}</Tag>
                            )}
                          {is_today &&
                            kist?.material_status === "niet inzetbaar" && (
                              <Tag color="error">{$t("Niet inzetbaar")}</Tag>
                            )}
                          {kist?.material_status == "in bedrijf" &&
                            kist.enable_inspections && (
                              <Inspection
                                inspection={inspections[kist.material_id]}
                                missingText={$t("Niet geinspecteerd")}
                                currentUserID={profile?.id}
                              />
                            )}
                        </div>
                      </Radio>
                    )
                );
              } catch (error) {
                console.error("Error rendering kist list:", error);
                return null;
              }
            })()}

            <Radio value={-1}>{$t("Leeg (voer zelf in)")}</Radio>
          </Space>
        </Radio.Group>
        
        <Divider style={{ margin: "4px 0" }} />
        
        {!showPriveKistSelection && (
          <Button
            type="primary"
            onClick={() => setShowPriveKistSelection(!showPriveKistSelection)}
          >
            {$t("Selecteer prive kist")}
          </Button>
        )}
        
        {showPriveKistSelection && (
          <div>
            <p className="title label spacer">{$t("Prive kisten")}</p>

            <Input
              placeholder={$t("Zoek op registratie of naam...")}
              value={priveKistSearchTerm}
              onChange={(e) => setPriveKistSearchTerm(e.target.value)}
              style={{ marginBottom: 12 }}
              allowClear
            />

            <Radio.Group
              onChange={(event) => setSelectedKistID(event.target.value)}
              value={selectedKistID}
            >
              <Space direction="vertical">
                {filteredPriveKisten.map((kist, key) => (
                  <Radio key={key} value={kist.id}>
                    <div style={{ display: "flex", gap: 24 }}>
                      <p>
                        {kist.callsign} {kist.registratie}
                      </p>
                    </div>
                  </Radio>
                ))}
              </Space>
            </Radio.Group>
          </div>
        )}
      </div>
    </Modal>
  );
};
